/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, February 22nd 2022, 2:48:20 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import { DndProvider } from "react-dnd";

export const OSDnDProvider = ({ children }) => {
  const isTouchDevice = React.useMemo(() => window.matchMedia("(pointer: coarse)").matches, []); // We only need to check for a touch screen device once. No need to re-check on subsequent renders

  const dragBackend = isTouchDevice ? TouchBackend : HTML5Backend;

  return <DndProvider backend={dragBackend}>{children}</DndProvider>;
};
